import React, { PropTypes } from 'react';
import { defaultLanguage, i18n } from 'helpers/i18n'

const context = function context(Component, params) {
  const wrapper = React.createClass({
    displayName: 'ContextWrapper',
    propTypes: {
      location: PropTypes.object,
      params: PropTypes.object,
      history: PropTypes.object,
      session: PropTypes.object,
      sessionId: PropTypes.string,
      program: PropTypes.object,
      nextLevel: PropTypes.string,
      setVideoState: PropTypes.func,
      deckState: PropTypes.object,
      showHUD: PropTypes.func,
      hideHUD: PropTypes.func,
      setDeviceRole: PropTypes.func,
      setTeamName: PropTypes.func,
      setScore: PropTypes.func,
      setMissionReportAnswer: PropTypes.func,
      setHackedAnswer: PropTypes.func,
      setMode: PropTypes.func,
      setCurrentLevel: PropTypes.func,
      setCurrentSlide: PropTypes.func,
      setLastSlide: PropTypes.func,
      completeLevel: PropTypes.func,
      setConfiguration: PropTypes.func,
      deckInterface: PropTypes.string,
      updateOnboardingState: PropTypes.func,
      registerHUDRef: PropTypes.func
    },
    contextTypes: {
      regionData: PropTypes.object
    },
    childContextTypes: {
      styles: PropTypes.object,
      flux: PropTypes.object,
      history: PropTypes.object,
      location: PropTypes.object,
      presenter: PropTypes.bool,
      overview: PropTypes.bool,
      export: PropTypes.bool,
      print: PropTypes.bool,
      slide: PropTypes.string,
      session: PropTypes.object,
      sessionId: PropTypes.string,
      program: PropTypes.object,
      nextLevel: PropTypes.string,
      setVideoState: PropTypes.func,
      mode: PropTypes.string,
      deckState: PropTypes.object,
      showHUD: PropTypes.func,
      hideHUD: PropTypes.func,
      setDeviceRole: PropTypes.func,
      setTeamName: PropTypes.func,
      setScore: PropTypes.func,
      setMissionReportAnswer: PropTypes.func,
      setHackedAnswer: PropTypes.func,
      setMode: PropTypes.func,
      setCurrentLevel: PropTypes.func,
      setCurrentSlide: PropTypes.func,
      setLastSlide: PropTypes.func,
      completeLevel: PropTypes.func,
      setConfiguration: PropTypes.func,
      deckInterface: PropTypes.string,
      updateOnboardingState: PropTypes.func,
      registerHUDRef: PropTypes.func,
      regionData: PropTypes.object,
      i18n: PropTypes.func
    },
    getChildContext() {
      let styles = {};
      const {
        location,
        session,
        sessionId,
        program,
        nextLevel,
        setVideoState,
        deckState,
        showHUD,
        hideHUD,
        setDeviceRole,
        history,
        setTeamName,
        setScore,
        setMissionReportAnswer,
        setHackedAnswer,
        setMode,
        setCurrentLevel,
        setCurrentSlide,
        setLastSlide,
        completeLevel,
        setConfiguration,
        deckInterface,
        updateOnboardingState,
        registerHUDRef
      } = this.props;
      const {
        regionData
      } = this.context;
      const { config } = program;
      if (location.query && 'print' in location.query) {
        styles = config.print;
      } else {
        styles = config.theme;
      }
      let slide = '1';
      if (this.props.params && 'slide' in this.props.params) {
        slide = this.props.params.slide;
      }
      return {
        styles,
        flux: params.flux,
        history,
        location,
        presenter: deckInterface === 'remoteControl',
        overview: location.query && 'overview' in location.query,
        export: location.query && 'export' in location.query,
        print: location.query && 'print' in location.query,
        slide,
        session,
        sessionId,
        program,
        nextLevel,
        setVideoState,
        deckState,
        showHUD,
        hideHUD,
        setDeviceRole,
        setTeamName,
        setScore,
        setMissionReportAnswer,
        setHackedAnswer,
        setMode,
        setCurrentLevel,
        setCurrentSlide,
        setLastSlide,
        completeLevel,
        setConfiguration,
        deckInterface,
        updateOnboardingState,
        registerHUDRef,
        regionData: {...regionData, contractId: session && session.contractId},
        i18n: i18n(session.language || defaultLanguage)
      };
    },

    render: function render() {
      return <Component {...this.props} />;
    }
  });
  return wrapper;
};

export default context;



// WEBPACK FOOTER //
// ./src/views/session/presentation/spectacle-ppa/src/utils/context.jsx